import { TDateAppFormat } from '@/domains/types';

import dayjs from '../dayjsConfig';
import { TGetIsDateBetweenOrSame } from '../domains/types';

const getIsDateBetweenOrSame: TGetIsDateBetweenOrSame = (
  date: number | string | TDateAppFormat | null,
  dateFrom: number | string | TDateAppFormat,
  dateTo: number | string | TDateAppFormat,
) => !!date && (dayjs(date).isAfter(dayjs(dateFrom)) || dayjs(date).isSame(dayjs(dateFrom)))
  && (dayjs(date).isBefore(dayjs(dateTo)) || dayjs(date).isSame(dayjs(dateTo)));

export default getIsDateBetweenOrSame;
